import {
	PhoenixDeployment,
	ModuleToDeploymentSettingsMap
} from 'phoenix/domain'

export class DeploymentService {
	private readonly deploymentsEndpoint: string;
	static $inject = [
		'$http',
		'settingsService'
	];
	
	constructor(
		private $http: ng.IHttpService,
		private settingsService: any
	) {
		this.deploymentsEndpoint = this.settingsService.serverAPIPath + '/admin/deployments';
	}
	
	/**
	* @ngdoc method
	* @name pxDeploymentService#createDeployment
	* @methodOf sharebase.services.pxDeploymentService
	* @kind function
	*
	* @description
	* Creates a new active deployment.
	*
	* @returns {Deferred} A promise that will resolve with the new deployment information.
	* 
	*/
	createDeployment(deployment: PhoenixDeployment) {
		return this.$http.post(this.deploymentsEndpoint, deployment)
			.then((response) => response.data as PhoenixDeployment);
	};
		
	/**
	* @ngdoc method
	* @name pxDeploymentService#updateDeployment
	* @methodOf sharebase.services.pxDeploymentService
	* @kind function
	*
	* @description
	* Updates the details of a ShareBase deployment.
	*
	* @returns {Deferred} A promise that will resolve with the updated deployment information.
	* 
	*/
	updateDeployment(deploymentId: number, deploymentDetails: Partial<PhoenixDeployment>) {
		return this.$http.patch(this.deploymentsEndpoint + '/' + deploymentId, deploymentDetails)
			.then((response) => response.data as PhoenixDeployment);
	};
		
	/**
	* @ngdoc method
	* @name pxDeploymentService#getDetails
	* @methodOf sharebase.services.pxDeploymentService
	* @kind function
	*
	* @description
	* Retrieves details of a ShareBase deployment.
	*
	* @returns {Deferred} A promise that will resolve with the details of a deployment.
	* 
	*/
	getDetails(deploymentId: number) {
		return this.$http.get(this.deploymentsEndpoint + '/' + deploymentId)
			.then((resp) => resp.data as PhoenixDeployment);
	};
		
	/**
	* @ngdoc method
	* @name pxDeploymentService#getSettings
	* @methodOf sharebase.services.pxDeploymentService
	* @kind function
	*
	* @description
	* Retrieves settings of a ShareBase deployment.
	*
	* @returns {Deferred} A promise that will resolve with the settings of a deployment.
	* 
	*/
	getSettings(deploymentId: number) {
		return this.$http.get(this.deploymentsEndpoint + '/' + deploymentId + '/settings')
			.then((resp) => resp.data as ModuleToDeploymentSettingsMap);
	};
		
	/**
	* @ngdoc method
	* @name pxDeploymentService#updateSettings
	* @methodOf sharebase.services.pxDeploymentService
	* @kind function
	*
	* @description
	* Updates the settings of a ShareBase deployment.
	*
	* @returns {Deferred} A promise that will resolve with the updated deployment settings.
	* 
	*/
	updateSettings(deploymentId:number, settings: ModuleToDeploymentSettingsMap) {
		return this.$http.patch(this.deploymentsEndpoint + '/' + deploymentId + '/settings', settings)
			.then((resp) => resp.data as ModuleToDeploymentSettingsMap);
	};
};


// WEBPACK FOOTER //
// ./src/phoenix/services/deploymentService.ts